export class EntrepreneurDetailsModel {

    public orgActivities: Array<number>;
    public customActivities: string;
    public regAuthority: string;
    public regDate: string;
    public regNumber: string;
    public unp: string;
    public parentUnp: string;

    constructor(obj?: any) {
        this.orgActivities      = obj && obj.orgActivities      || [];
        this.customActivities   = obj && obj.customActivities   || '';
        this.regAuthority       = obj && obj.regAuthority       || '';
        this.regDate            = obj && obj.regDate            || '';
        this.regNumber          = obj && obj.regNumber          || '';
        this.unp                = obj && obj.unp                || '';
        this.parentUnp          = obj && obj.parentUnp          || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/entrepreneur-details.model.ts